import { InMemoryCache, ApolloLink, CombinedGraphQLErrors, CombinedProtocolErrors } from '@apollo/client/core';
import { ErrorLink } from '@apollo/client/link/error';
import { environment } from 'environments/environment';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { WebSocketLink } from '@apollo/client/link/ws';
import { createClient } from 'graphql-ws';
import { RetryLink } from '@apollo/client/link/retry';
import { ApplicationConfig, inject } from '@angular/core';
import { Apollo, APOLLO_NAMED_OPTIONS } from 'apollo-angular';
import { apolloInitializer2 } from './apollo-init2';
import { apolloInitializerDatwind } from './apollo-init-datwind';
import { apolloInitializerNotifications } from './apollo-init-notifications';
import Keycloak from 'keycloak-js';
import { apolloInitializerMultitech } from './apollo-init-multitech';

export function apolloInitializer() {

  const keycloakInstance = inject(Keycloak);
  const token = keycloakInstance.token;

  const retryLink = new RetryLink({
    attempts: {
      max: 10,
      retryIf: (error) => !!error,
    },
    delay: {
      initial: 30000,
      max: 30000,
      jitter: false,
    },
  });

  // const webSocket = new WebSocketLink({
  //   uri: environment.graphql_ws,
  //   options: {
  //     reconnect: true,
  //     connectionParams: {
  //       authToken: `Bearer ${token}`,
  //     }
  //   },
  // });

  /*
    This way to create the socket connection is the correct one.
    But since tha api-server-rt is using an old library, we should continue using the old approach
  */
  const webSocket = new GraphQLWsLink(createClient({
    url: environment.graphql_ws,
    connectionParams: {
      authToken: `Bearer ${token}`,
    }
  }));

  const errorLink = new ErrorLink(({ error, operation }) => {
    if (CombinedGraphQLErrors.is(error)) {
      error.errors.forEach(({ message, locations, path }) =>
        console.error(`[GraphQL error APIv1]: Message: "${message}", Operation: ${operation}, Path: ${path}, Locations: ${locations}`),
      );
    } else if (CombinedProtocolErrors.is(error)) {
      error.errors.forEach(({ message, extensions }) =>
        console.error(`[GraphQL error APIv1]: Message: "${message}", Extensions: ${JSON.stringify(extensions)}`),
      );
    } else {
      console.error(`[Network error APIv1]: ${error.name}`);
    }
  });

  const webSocketOptions = {
    link: ApolloLink.from([errorLink, retryLink, webSocket]),
    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            pexapark: {
              merge: false
            },
          },
        },
        ForecastAccuracy: {
          merge: false
        },
        Country: {
          merge: true,
        },
        User: {
          fields: {
            preferences: {
              merge: false
            },
            user_portfolios: {
              merge: false
            },
          },
        }
      }
    })
  }

  return {
    '': webSocketOptions,
    ...apolloInitializer2(),
    ...apolloInitializerDatwind(),
    ...apolloInitializerNotifications(),
    ...apolloInitializerMultitech()
  };

}

export const graphqlProvider: ApplicationConfig['providers'] = [
  Apollo,
  {
    provide: APOLLO_NAMED_OPTIONS,
    useFactory: apolloInitializer
  },
]
